import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core'

import { MatButtonModule } from '@angular/material/button'
import { MatIconModule } from '@angular/material/icon'
import { MatTooltipModule } from '@angular/material/tooltip'
import { TranslateModule } from '@ngx-translate/core'
import { GbDashboardSharedUiModule, IconLibrary } from '@galabid/gb-dashboard/shared/ui'

@Component({
  selector: 'gb-presenter-tools-general',
  imports: [MatButtonModule, MatIconModule, MatTooltipModule, TranslateModule, GbDashboardSharedUiModule],
  templateUrl: './gb-presenter-tools-general.component.html',
  styleUrl: './gb-presenter-tools-general.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GbPresenterToolsGeneralComponent {
  @Input() canUndo = true
  @Input() canRedo = true

  @Output() undo = new EventEmitter<void>()
  @Output() redo = new EventEmitter<void>()
  @Output() copy = new EventEmitter<void>()
  @Output() paste = new EventEmitter<void>()
  @Output() delete = new EventEmitter<void>()

  IconLibrary = IconLibrary

  get undoShortcutLabel(): string {
    return this.isMacLikePlatform() ? '⌘Z' : 'Ctrl+Z'
  }

  get redoShortcutLabel(): string {
    return this.isMacLikePlatform() ? '⇧⌘Z' : 'Shift+Ctrl+Z'
  }

  get copyShortcutLabel(): string {
    return this.isMacLikePlatform() ? '⌘C' : 'Ctrl+C'
  }

  get pasteShortcutLabel(): string {
    return this.isMacLikePlatform() ? '⌘V' : 'Ctrl+V'
  }

  get deleteShortcutLabel(): string {
    return this.isMacLikePlatform() ? '⌫' : 'Del'
  }

  onUndo(): void {
    this.undo.emit()
  }

  onRedo(): void {
    this.redo.emit()
  }

  onCopy(): void {
    this.copy.emit()
  }

  onDelete(): void {
    this.delete.emit()
  }

  onPaste(): void {
    this.paste.emit()
  }

  private isMacLikePlatform(): boolean {
    const nav = globalThis.navigator as Navigator & {
      userAgentData?: {
        platform?: string
      }
    }

    const platform = (nav?.userAgentData?.platform ?? '').toLowerCase()
    if (platform) {
      return platform.includes('mac') || platform.includes('ios')
    }

    const userAgent = (nav?.userAgent ?? '').toLowerCase()
    return (
      userAgent.includes('mac os') ||
      userAgent.includes('macintosh') ||
      userAgent.includes('iphone') ||
      userAgent.includes('ipad')
    )
  }
}
